<!-- // todo: migrate to iota-modal -->
<div class="modal-box w-[30vw] max-w-full max-h-full p-4 resize" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="flex flex-row items-center justify-between border-b-2 pb-1" cdkDragHandle>
        <span class="font-bold text-lg whitespace-pre-wrap break-words" i18n>Request new document</span>

        <button class="btn btn-ghost btn-circle" mat-dialog-close>
            <iota-icon icon="x-mark" size="1.5"></iota-icon>
        </button>
    </div>

    <div class="form-control w-full">
        <label class="label">
            <span class="label-text" i18n>Reason *</span>
        </label>
        <input
            type="text"
            i18n-placeholder
            placeholder="Reason..."
            class="input input-bordered w-full"
            maxlength="500"
            [(ngModel)]="reason"
        />
    </div>

    <div class="form-control">
        <label class="label">
            <span class="label-text" i18n>News</span>
        </label>
        <textarea
            class="textarea textarea-bordered h-32"
            i18n-placeholder
            placeholder="News..."
            maxlength="5000"
            [(ngModel)]="message"
        ></textarea>
    </div>

    <div class="flex flex-row items-center justify-between mt-4">
        <button class="btn" mat-dialog-close i18n>Cancel</button>

        <button class="btn btn-primary" (click)="requestResubmission()" [disabled]="!reason || reason.trim().length === 0" i18n>
            Request a new one now
        </button>
    </div>
</div>
